<template>
  <div>
    <div class="eu-flex">
      <div class="eu-flex-item eu-basis_12 eu-basis_12_md">
        <emd-alert v-if="showAlert" variant="danger" @cancel="showAlert = false">
          <template slot="content">
            <p v-for="(error, index) in errors" :key="index">{{ error.message }}</p>
          </template>
        </emd-alert>
      </div>
      <div class="eu-flex-item eu-basis_12 eu-basis_8_md eu-pt_5 _spacing ">
        <CreditCard @formIsValid="formValidation($event, 'credit_card')" v-if="creditCardEnabled"/>
        <Boleto @formIsValid="formValidation($event, 'boleto')" v-if="boletoEnabled"/>
        <Pix @formIsValid="formValidation($event, 'pix')" v-if="pixEnabled"/>
      </div>
      <div class="eu-flex-item eu-basis_12 eu-basis_4_md">
        <Summary expanded />
      </div>
    </div>
    <div class="el-section">
      <div class="eu-display_flex">
        <button class="emd-btn _color_secondary _type_text _block_mobile" @click="goBack" :disabled="loading">
          <i class="uil uil-angle-left"></i>
          {{ $t('back') }}
        </button>
        <button class="emd-btn _color_secondary _block_mobile eu-ml_auto" @click="end" :disabled="isEndDisable">
          <emd-loader v-if="loading" />
          <span v-else>{{ $t('end') }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Pix from './PaymentMethods/Pix.vue'
import Boleto from './PaymentMethods/Boleto.vue'
import CreditCard from './PaymentMethods/CreditCard.vue'
import Summary from '../../components/project/Summary/Summary.vue'
import EmdAlert from '@/components/emerald/molecules/EmdAlert'
import EmdLoader from '@/components/emerald/atoms/EmdLoader'
import { formatToInt, formatCurrency, formatToFloat } from '@/utils/validations'

export default {
  name: 'PaymentMethods',
  components: {
    Pix,
    Boleto,
    CreditCard,
    Summary,
    EmdAlert,
    EmdLoader
  },
  data () {
    return {
      showAlert: false,
      loading: false,
      errors: [],
      boletoIsValid: false,
      pixIsValid: false,
      cardIsValid: false
    }
  },
  created () {
    if (!this.creditCardEnabled) {
      this.$store.dispatch('CREDIT_CARD_PAYMENT', false)
    }
    if (!this.pixEnabled) {
      this.$store.dispatch('PIX_PAYMENT', false)
    }
    if (!this.boletoEnabled) {
      this.$store.dispatch('BOLETO_PAYMENT', false)
    }
  },
  computed: {
    ...mapGetters(['address', 'orderCode']),
    formIsValid () {
      return (this.boletoIsValid && this.paymentMethods.boleto_enabled) || (this.pixIsValid && this.paymentMethods.pix_enabled) || (this.cardIsValid && this.paymentMethods.credit_card_enabled)
    },
    creditCardEnabled () {
      return this.$store.getters.paymentMethodsEnabled.find(item => item === 'credit_card')
    },
    boletoEnabled () {
      return this.$store.getters.paymentMethodsEnabled.find(item => item === 'boleto')
    },
    pixEnabled () {
      return this.$store.getters.paymentMethodsEnabled.find(item => item === 'pix')
    },
    isEndDisable () {
      return this.loading || !this.hasSelectedPaymentMethod
    },
    routesWizard () {
      return this.$store.getters.routesWizard
    },
    paymentLinkData () {
      return this.$store.getters.paymentLinkData
    },
    paymentMethods () {
      return this.$store.getters.paymentMethods
    },
    paymentLinkItems () {
      return this.$store.getters.paymentLinkItems
    },
    paymentLinkShipping () {
      return this.$store.getters.paymentLinkShipping
    },
    customerData () {
      return this.$store.getters.customerData
    },
    accountId () {
      return this.$store.getters.accountData.id
    },
    merchantId () {
      return this.$store.getters.merchantData.id
    },
    maxPaidSessions () {
      if (this.paymentLinkData.max_paid_sessions === this.$t('noLimit')) {
        return 0
      }
      return Number(this.paymentLinkData.max_paid_sessions)
    },
    shipping () {
      return this.$store.getters.paymentLinkShipping
    },
    items () {
      this.paymentLinkItems.forEach(item => {
        item.amount = formatToInt(item.amount)
      })

      return this.paymentLinkItems
    },
    hasSelectedPaymentMethod () {
      return Object.values(this.paymentMethods).some(paymentMethod => paymentMethod === true)
    },
    showFeedbacks: {
      get () {
        return this.$store.getters.showFeedbacks
      },
      set (newValue) {
        this.$store.dispatch('SHOW_FEEDBACK_STATUS', newValue)
      }
    },
    isShopCreate () {
      return !this.$store.getters.permissionIsEnabled('shop.checkout:create') || !this.$store.getters.permissionIsEnabled('shop.recurrence:create')
    }

  },
  methods: {
    formValidation (value, method) {
      if (method === 'boleto') {
        this.boletoIsValid = value
      } else if (method === 'pix') {
        this.pixIsValid = value
      } else if (method === 'credit_card') {
        this.cardIsValid = value
      }

      if (!(this.boletoIsValid || this.pixIsValid || this.cardIsValid)) this.showFeedbacks.status = false
    },
    goBack () {
      this.$store.dispatch('CHANGE_STATUS', 'link-settings')
      this.$router.push({ name: 'Link' })
    },
    subtotalItem (item) {
      if (item.default_quantity && item.amount) {
        const quantity = item.default_quantity
        const amount = formatToInt(item.amount)
        const subtotal = (amount * quantity) / 100

        return subtotal
      }

      return 0
    },
    subtotal () {
      const items = this.items
      let sum = 0

      items.forEach(item => {
        sum = sum + this.subtotalItem(item)
      })

      return formatCurrency(sum)
    },
    total () {
      const shipping = formatToInt(this.shipping)
      const subtotal = formatToInt(this.subtotal())

      return shipping + subtotal
    },
    acceptedPaymentMethods () {
      const paymentMethods = []

      if (this.paymentMethods.pix_enabled) {
        paymentMethods.push('PIX')
      }

      if (this.paymentMethods.boleto_enabled) {
        paymentMethods.push('BOLETO')
      }

      if (this.paymentMethods.credit_card_enabled) {
        paymentMethods.push('CREDIT_CARD')
      }

      return paymentMethods
    },
    pixPayment () {
      let pixSettings = {}

      pixSettings = {
        expires_in: (this.paymentLinkData.pix_settings.expires_in * 3600)
      }

      if (!this.paymentLinkData.pix_settings.has_discount) {
        return pixSettings
      }

      if (this.paymentLinkData.pix_settings.discount_type === 'money') {
        pixSettings.discount = formatToInt(this.paymentLinkData.pix_settings.discount)
      } else if (this.paymentLinkData.pix_settings.discount_type === 'percentage') {
        pixSettings.discount_percentage = formatToFloat(this.paymentLinkData.pix_settings.discount)
      }

      return pixSettings
    },
    freeInstallments () {
      if (Number(this.paymentLinkData.credit_card_settings.max_installments) === Number(this.paymentLinkData.credit_card_settings.rated_installments)) {
        return 0
      } else if (Number(this.paymentLinkData.credit_card_settings.rated_installments) === 0) {
        return Number(this.paymentLinkData.credit_card_settings.max_installments)
      } else {
        return Number(this.paymentLinkData.credit_card_settings.rated_installments)
      }
    },
    creditCardPayment () {
      const creditCardSettings = {
        operation_type: this.paymentLinkData.credit_card_settings.operation_type,
        installments_setup: {
          customer_fee: true,
          interest_type: 'simple',
          amount: this.total(),
          free_installments: this.freeInstallments(),
          interest_rate: Number(this.paymentLinkData.credit_card_settings.rated_installments) > 0 ? formatToFloat(this.paymentLinkData.credit_card_settings.interest_rate) : 0,
          max_installments: Number(this.paymentLinkData.credit_card_settings.max_installments)
        }
      }

      return creditCardSettings
    },
    boletoPayment () {
      let boletoSettings = {}

      boletoSettings = {
        due_in: this.paymentLinkData.boleto_settings.due_in
      }

      if (!this.paymentLinkData.boleto_settings.has_discount) {
        return boletoSettings
      }

      if (this.paymentLinkData.boleto_settings.discount_type === 'money') {
        boletoSettings.discount = formatToInt(this.paymentLinkData.boleto_settings.discount)
      } else if (this.paymentLinkData.boleto_settings.discount_type === 'percentage') {
        boletoSettings.discount_percentage = formatToFloat(this.paymentLinkData.boleto_settings.discount)
      }

      return boletoSettings
    },
    paymentParam () {
      const param = {
        is_building: false,
        type: 'order',
        name: this.paymentLinkData.name || this.items[0].name,
        expires_in: this.paymentLinkData.expiresIn,
        max_paid_sessions: this.maxPaidSessions,
        payment_settings: {
          accepted_payment_methods: this.acceptedPaymentMethods()
        },
        cart_settings: {
          shipping_cost: formatToInt(this.paymentLinkShipping),
          items: this.items
        },
        address: this.address,
        order_code: this.orderCode ? this.orderCode : null
      }

      if (this.maxPaidSessions === 1 && this.paymentLinkData.customerInformation) {
        const customer = {}

        if (this.customerData.name) {
          customer.name = this.customerData.name
        }
        if (this.customerData.email) {
          customer.email = this.customerData.email
        }

        param.customer_settings = {
          customer: customer
        }
      }

      if (this.paymentMethods.pix_enabled) {
        param.payment_settings.pix_settings = this.pixPayment()
      }

      if (this.paymentMethods.boleto_enabled) {
        param.payment_settings.boleto_settings = this.boletoPayment()
      }

      if (this.paymentMethods.credit_card_enabled) {
        param.payment_settings.statement_descriptor = this.paymentLinkData.credit_card_settings.statement_descriptor
        param.payment_settings.credit_card_settings = this.creditCardPayment()
      }

      return param
    },
    end () {
      if (!this.loading) {
        if (this.formIsValid) {
          this.showFeedbacks.status = true
        } else if (this.isShopCreate) {
          this.showReadOnlyAlert()
        } else {
          this.loading = true
          this.showAlert = false
          this.$store.dispatch('CREATE_PAYMENT_LINK', {
            merchantId: this.merchantId,
            accountId: this.accountId,
            body: this.paymentParam()
          }).then(response => {
            this.onSuccess(response)
            this.loading = false
          }).catch(() => {
            this.errors = [this.$t('error.alert')]
            this.showAlert = true
            this.loading = false
          })
        }
      }
    },
    onSuccess (response) {
      this.$store.dispatch('UPDATE_DATA',
        {
          value: response.payment_url,
          attribute: 'url'
        }
      )

      this.$store.dispatch('UPDATE_DATA',
        {
          value: response.id,
          attribute: 'order_id'
        }
      )

      this.routesWizard = this.routesWizard.map(item => {
        if (item.path === 'success') item.permission = true
        return item
      })
      this.$router.push({ path: 'success' })
    },
    showReadOnlyAlert () {
      this.errors = [this.$t('error.readOnly')]
      this.showAlert = true
      this.loading = false
    }
  }
}
</script>

<style scoped>
._spacing {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
</style>

<i18n>
{
  "pt-BR": {
    "back": "Voltar",
    "end": "Concluir",
    "noLimit": "Sem limite",
    "error": {
      "title": "Erro",
      "alert": {
        "message": "Não foi possível criar o link de pagamento. Tente de novo em alguns minutos."
      },
      "readOnly": {
        "message": "Você não possui permissão para criar transações no Shop"
      },
      "credit_card": {
        "message": "Não foi possível finalizar o pagamento."
      },
      "boleto": {
        "message": "Não foi possível criar o boleto."
      },
      "checkout": {
        "message": "Não foi possível criar o link de pagamento."
      },
      "default": {
        "message": "Não foi possível finalizar a criação do pedido."
      }
    }
  },
  "en-US": {
    "back": "Back",
    "end": "End",
    "noLimit": "No limit",
    "error": {
      "title": "Error",
      "alert": {
        "message": "Unable to create payment link. Try again in a few minutes."
      },
      "credit_card": {
        "message": "Could not create payment."
      },
      "boleto": {
        "message": "Could not create boleto."
      },
      "checkout": {
        "message": "Could not create payment link."
      },
      "subscription": "Subscription details"
    }
  }
}
</i18n>
